<template>
  <div id="app">
    <div class="main-wrapper">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useDataStore } from '@/store/dataStore';

const { loadAllData } = useDataStore();

onMounted(() => {
  loadAllData();
});
</script>

<style>
/* Global padding for mobile */
@media (max-width: 991.98px) {
  .page-wrapper {
    padding-top: 0 !important;
    margin-top: 0 !important;
    margin-left: 0 !important;
  }
  .main-wrapper {
    padding-top: 0 !important;
  }
}
</style>

